import { StateCreator } from 'zustand';
import { SortDirection } from '../types.ts';

export const scope = 'workflows';

type State = {
  workflowsSelectedWorkflowId: string | null;
  workflowsSortColumn: string;
  workflowsSortDirection: SortDirection;
};

type Actions = {
  setWorkflowsSelectedWorkflowId: (workflowId: string | null) => void;
  setWorkflowsSortColumn: (sortColumn: string) => void;
  setWorkflowsSortDirection: (direction: SortDirection) => void;
};

export type WorkflowsSlice = State & Actions;

const VALID_SORT_COLUMNS = ['created_at', 'name'];
const VALID_SORT_DIRECTIONS: SortDirection[] = ['', '-'];

export const createWorkflowsSlice: StateCreator<WorkflowsSlice, [['zustand/immer', never]], [], WorkflowsSlice> = (
  set,
) => {
  const savedSortColumn = localStorage.getItem('workflowsSortColumn');
  const savedSortDirection = localStorage.getItem('workflowsSortDirection') as SortDirection | null;

  const initialSortColumn =
    savedSortColumn && VALID_SORT_COLUMNS.includes(savedSortColumn) ? savedSortColumn : 'created_at';
  const initialSortDirection =
    savedSortDirection !== null && VALID_SORT_DIRECTIONS.includes(savedSortDirection) ? savedSortDirection : '-';

  return {
    workflowsSelectedWorkflowId: null,
    workflowsSortColumn: initialSortColumn,
    workflowsSortDirection: initialSortDirection,
    setWorkflowsSelectedWorkflowId: (workflowsSelectedWorkflowId) => set(() => ({ workflowsSelectedWorkflowId })),
    setWorkflowsSortColumn: (workflowsSortColumn) =>
      set(() => {
        localStorage.setItem('workflowsSortColumn', workflowsSortColumn);
        return { workflowsSortColumn };
      }),
    setWorkflowsSortDirection: (workflowsSortDirection) =>
      set(() => {
        localStorage.setItem('workflowsSortDirection', workflowsSortDirection);
        return { workflowsSortDirection };
      }),
  };
};
